import React from 'react';
import LocationFields from '@/components/LocationFields';
import LocationPicker from '@/components/LocationPicker';
import {validCoordinates} from '@/components/LocationMap';
import {useLang} from '@/i18n/LanguageContext';

export default function SubjectLocationFields({value,onChange,prefix='location'}){
 const {lang}=useLang(),it=lang==='it';
 const selected=validCoordinates(value);
 const addressChange=next=>{
  const changed=['country','region','municipality','locality'].some(key=>next[key]!==value[key]);
  onChange(changed ? {...next,lat:null,lng:null,approximate:true,manual_coordinates:false} : next);
 };
 return <div data-testid={`${prefix}-subject-location`}>
  <LocationFields value={value} onChange={addressChange} prefix={prefix}/>
  <fieldset className="border rounded-lg p-3 mt-4"><legend className="px-1 text-sm">{it?'Posizione sulla mappa':'Map location'}</legend>
   <p className="text-sm text-[#6E6258]">{it?'Puoi indicare il punto esatto cliccando sulla mappa. Senza un punto selezionato, la posizione sarà ricercata dall’indirizzo al salvataggio. Il punto non rappresenta i confini catastali.':'Choose the precise location by clicking the map. If no point is selected, the address will be used to find the location when saving. The marker does not represent cadastral boundaries.'}</p>
   {selected && <p className="text-sm mt-2" data-testid={`${prefix}-coordinates`}>{value.lat.toFixed(6)}, {value.lng.toFixed(6)}</p>}
   <LocationPicker location={selected?value:null} lang={lang} onChange={point=>onChange({...value,...point,approximate:false,manual_coordinates:true})}/>
   {selected && <button type="button" className="text-sm underline mt-2" onClick={()=>onChange({...value,lat:null,lng:null,approximate:true,manual_coordinates:false})}>{it?'Rimuovi il punto e usa l’indirizzo':'Remove marker and use address'}</button>}
  </fieldset>
 </div>;
}
